import React from 'react';
import { connect } from 'react-redux';
import HistoricDateField from './HistoricDateField';

function DateField(props) {
  return <HistoricDateField {...props} />;
}

function mapStateToProps(state) {
  return {
    monthFirst: state.settings.dateFormat === 'US',
  };
}

export default connect(mapStateToProps)(DateField);
